import {
  IProposalDeductionSectionProps,
  IProposalMonthlySalaryPackagingDeductionsProps,
} from './proposalInterfaces/deductionSectionProps'

const DetermineTaxShareGST = (isExGST: boolean, taxShare: string) => {
  return (
    (isExGST ? 'Ex' : 'Inc') +
    'GST' +
    (taxShare.toLowerCase() == 'yes' ? 'TaxShare' : '')
  )
}

export const MonthlySalaryPackagingDeductions = (
  isExGST: boolean,
  estimate: IProposalMonthlySalaryPackagingDeductionsProps
) => {
  //<div>Total Salary Packaging Deductions</div>
  var result = 0
  var whichValue = DetermineTaxShareGST(isExGST, estimate.taxShare)
  switch (whichValue) {
    case 'ExGST':
      result = estimate.totalPackagePerPayExGST
      break
    case 'ExGSTTaxShare':
      result = estimate.totalPackagePerPayExGSTTaxShare
      break
    case 'IncGST':
      result = estimate.totalPackagePerPayIncGST
      break
    case 'IncGSTTaxShare':
      result = estimate.totalPackagePerPayExGSTTaxShare * 1.1
      break
  }

  return result
}

export const IsExGST = (employer: {
  employerGRS?: { gstExclusiveDeductionsCode?: string }
}) => {
  let result = false
  if (
    employer &&
    employer.employerGRS &&
    employer.employerGRS.gstExclusiveDeductionsCode
  )
    result =
      employer.employerGRS.gstExclusiveDeductionsCode.toLowerCase() === 'yes'

  return result
}
